$('.js-partnersSlider').slick({
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: '<div type="button" class="slick-next"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
    prevArrow: '<div type="button" class="slick-prev"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 760,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
    ]
});